import { useDashboard } from "@/hooks/dashboard/useDashboard";
import NotificationsSecretariat from "@/pages/dashboard/(components)/NotificationsSecretariat";
import OnboardingBanner from "@/pages/dashboard/(components)/OnboardingBanner";
import QuickActions from "@/pages/dashboard/(components)/QuickActions";
import { useEmpreendedoraStore } from "@/stores/empreendedoraStore";
import { Loading } from "@uigovpe/components";
import { useEffect, useRef, useState } from "react";

const STATUS_DISMISSED_KEY = "empreende-mulher:dashboard-status-dismissed";

function hasDismissedStatus() {
  try {
    return window.localStorage.getItem(STATUS_DISMISSED_KEY) === "true";
  } catch {
    return false;
  }
}

export default function Dashboard() {
  const { dashboardData, isLoading, getDashboard } = useDashboard();
  const nome = useEmpreendedoraStore((state) => state.nome);
  const [statusDismissed, setStatusDismissed] = useState(hasDismissedStatus);
  const [statusClosing, setStatusClosing] = useState(false);
  const dismissTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const dismissStatus = () => {
    if (statusClosing) return;
    setStatusClosing(true);
    try {
      window.localStorage.setItem(STATUS_DISMISSED_KEY, "true");
    } catch {
      // A preferência continua válida durante a sessão atual.
    }
    dismissTimeoutRef.current = setTimeout(() => {
      setStatusDismissed(true);
      setStatusClosing(false);
    }, 250);
  };

  useEffect(() => {
    void getDashboard().catch(() => undefined);
  }, [getDashboard]);

  useEffect(
    () => () => {
      if (dismissTimeoutRef.current) clearTimeout(dismissTimeoutRef.current);
    },
    [],
  );

  if (isLoading) {
    return (
      <div
        className="flex min-h-[320px] w-full items-center justify-center"
        role="status"
        aria-live="polite"
        aria-label="Carregando dashboard"
      >
        <Loading />
        <span className="sr-only">Carregando dashboard...</span>
      </div>
    );
  }

  const showRaisedPerformance =
    dashboardData.dashboard.perfilCompleto && statusDismissed;

  return (
    <div className="dashboard-page flex! min-w-0! flex-col! gap-5!">
      <header className="flex! flex-col! gap-0!">
        <h1 className="m-0! text-[30px]! leading-[36px]! font-bold! text-[#494c57]!">
          Olá, {nome || "Empreendedora"}! Que bom ter você aqui.
        </h1>
        <p className="mt-3! text-[18px]! leading-[20px]! font-normal! text-[#494c57]!">
          Vamos impulsionar seu negócio hoje?
        </p>
      </header>
      <OnboardingBanner
        checklist={dashboardData.dashboard}
        products={dashboardData.produtos}
        visibility={dashboardData.visibilidade}
        statusDismissed={showRaisedPerformance}
        statusClosing={statusClosing}
        onDismissStatus={dismissStatus}
      />
      {/* teste de referencia */}
      <QuickActions
        visibility={dashboardData.visibilidade}
        hideVisibility={showRaisedPerformance}
        profileComplete={dashboardData.dashboard.perfilCompleto}
      />
      <NotificationsSecretariat />
    </div>
  );
}
